import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/configs/routes';
import { isLegacyAuth } from '@/services/auth/authUtils';

interface LegacyAuthRouteProps {
  children: React.ReactNode;
}

const LegacyAuthRoute = ({ children }: LegacyAuthRouteProps): JSX.Element => {
  if (!isLegacyAuth()) {
    return <Navigate to={ROUTES.DASHBOARD.ROOT} replace />;
  }

  return children as JSX.Element;
};

export default LegacyAuthRoute;
